(function(){
  function applyLang(l){
    document.querySelectorAll('.tv-root').forEach(function(root){
      root.setAttribute('data-tv-active-lang', l);
    });
    document.querySelectorAll('.tv-lang-btn').forEach(function(btn){
      btn.textContent = l === 'tr' ? 'EN' : 'TR';
    });
  }
  function getLang(){
    try { return localStorage.getItem('tivart-lang') || 'tr'; } catch(e){ return 'tr'; }
  }
  function setLang(l){
    try { localStorage.setItem('tivart-lang', l); } catch(e){}
    applyLang(l);
  }
  document.addEventListener('DOMContentLoaded', function(){
    applyLang(getLang());
    document.querySelectorAll('.tv-lang-btn').forEach(function(btn){
      btn.addEventListener('click', function(){
        setLang(getLang() === 'tr' ? 'en' : 'tr');
      });
    });
    var path = window.location.pathname.replace(/\/$/, '');
    document.querySelectorAll('.tv-nav a[data-tv-path]').forEach(function(a){
      var p = a.getAttribute('data-tv-path').replace(/\/$/, '');
      if (p === path) a.classList.add('is-active');
    });
    var lightbox = document.querySelector('.tv-lightbox');
    if (lightbox){
      var img = lightbox.querySelector('img');
      document.querySelectorAll('[data-tv-lightbox-src]').forEach(function(el){
        el.addEventListener('click', function(){
          img.src = el.getAttribute('data-tv-lightbox-src');
          lightbox.classList.add('is-open');
        });
      });
      lightbox.addEventListener('click', function(e){
        if (e.target === lightbox || e.target.classList.contains('tv-lightbox-close')){
          lightbox.classList.remove('is-open');
        }
      });
    }
  });
})();
